import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.json.parse.js";
import "core-js/modules/es.json.stringify.js";
const FAVORITE_UNITS_KEY = "iwork-favorite-units";
export function getFavoriteUnits() {
  try {
    return JSON.parse(localStorage.getItem(FAVORITE_UNITS_KEY) || "[]");
  } catch (error) {
    return [];
  }
}
export function setFavoriteUnits(unitIds) {
  localStorage.setItem(FAVORITE_UNITS_KEY, JSON.stringify(unitIds));
}
export function isFavoriteUnit(unitId) {
  return getFavoriteUnits().includes(unitId);
}
export function toggleFavoriteUnit(unitId) {
  const favoriteUnits = getFavoriteUnits();
  const unitIndex = favoriteUnits.indexOf(unitId);
  if (unitIndex >= 0) {
    favoriteUnits.splice(unitIndex, 1);
  } else {
    favoriteUnits.push(unitId);
  }
  setFavoriteUnits(favoriteUnits);
  return favoriteUnits.slice();
}